<template>
  <sui-form-field :width="field.width || width || 16" :required="field.required" :error="isInvalid" v-if="field && !field.hidden">
    <label v-show="field.label">
      {{field.label}}
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="field.warning" v-if="field.warning"><i class="warning sign yellow fitted icon" /></span>
      <span class="tooltip" data-inverted data-position="left center" :data-tooltip="tooltip" v-if="tooltip"><i class="help circle blue fitted icon" /></span>
    </label>
    <div class="row">
      <sui-input v-model.trim="$attrs.value" :loading="generating" :icon="icon" v-autoselect="field.autoselect || false" :disabled="field.readonly" placeholder="no password" @input="onInput" @blur="onBlur" />
      <div class="ui icon button" :class="{disabled: field.readonly}" data-inverted data-position="top right" :data-tooltip="tooltipGenerate" @click.prevent="generatePassword()" data-goal="SERVICE_FORM_PASSWORD_GENERATE">
        <i class="refresh icon" />
      </div>
      <div class="ui icon button" :class="{disabled: !$attrs.value}" data-inverted data-position="top right" :data-tooltip="tooltipCopy" @click.prevent="copyPassword()" data-goal="SERVICE_FORM_PASSWORD_COPY">
        <i class="copy icon" />
      </div>
    </div>
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'
  import utils from '@/utils'

  export default {
    name: 'FormEntityPassword',
    mixins: [
      FormField,
    ],
    data() {
      return {
        generating: false,
        tooltipGenerate: 'Generate password',
        tooltipCopy: 'Copy password',
      }
    },
    methods: {
      onInput() {
        this.$emit('input', this.$attrs.value)
      },
      onBlur() {
        this.changed = true
      },
      generatePassword() {
        if (!this.generating) {
          this.generating = true
          this.tooltipGenerate = 'Generating password...'
          setTimeout(() => {
            this.generating = false
            this.tooltipGenerate = 'Generated!'
            this.$attrs.value = utils.generatePassword()
            this.onInput()
            setTimeout(() => {
              this.tooltipGenerate = 'Generate password'
            }, 1000)
          }, 300)
        }
      },
      copyPassword() {
        if (this.$attrs.value) {
          this.$copyText(this.$attrs.value).then(() => {
            this.tooltipCopy = 'Copied!'
          }, () => {
            this.tooltipCopy = 'Can\'t copy!'
          })
          setTimeout(() => {
            this.tooltipCopy = 'Copy password'
          }, 1000)
        }
      },
    },
  }
</script>

<style scoped>
  .tooltip { float: right; }
  .row { display: flex; }
  .button { margin: 0 0 0 1em!important; }
  .button + .button { margin: 0 0 0 .3em!important; }
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
